module.exports = __webpack_public_path__ + "static/img/banner_mobile.9c05389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gene_second/banner_mobile.png
// module id = B0ig
// module chunks = 16